<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LYDr1E/images/9781455535200_cover_epub.jpg?1733067596054" alt="This image is the cover for the book Compromised, Alpha Ops Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Compromised, Alpha Ops Series
      </h1>
      <p class="bookDescription body article font2">
        <p>It was supposed to be the happiest day of her life. <br/><br/> But when her wedding erupts in gunfire, Sadie Walker realizes this is <i>not</i> the life she wants-her fiance's work with Delta Force will always cast a shadow over their relationship. After leaving the hard-muscled hero at the altar, she thinks she'll never see him again . . . until a chance encounter reveals that he still has a strong grip on her heart. <br/><br/> On a covert assignment overseas, Simon Tennant is shocked when he spots Sadie with another man. Jealousy flares, as does an irresistible urge to keep her protected. Amid a dangerous game of international espionage, he'll have to convince Sadie just how perfect they've always been together. This time, nothing will take precedence over winning her back, no matter the cost to his cover-or his life . . .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emmy Curtis
      </h2>
      
      <p class="authorDescription body article"><B>Emmy Curtis</B> is an editor and a romance writer. An ex-pat Brit, she quells her homesickness with Cadbury Flakes and Fray Bentos pies. She's lived in London, Paris, and New York, and has settled for the time being, in North Carolina. When not writing, Emmy loves to travel with her military husband and take long walks with their Lab. All things considered, her life is chock full of hoot, just a little bit of nanny. And if you get that reference . . . well, she already considers you kin.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34ba57e8